module.exports = __webpack_public_path__ + "img/mission.4aa9a481.jpg";